import { CommandUpdateTitle } from "messages";

const DEFAULT_TITLE = "Sunrun ONE";

const handleUpdateTitle = (message: CommandUpdateTitle) => {
  if ("reset" in message.payload && message.payload.reset) {
    document.title = DEFAULT_TITLE;
  } else if ("text" in message.payload) {
    document.title = message.payload.text ?? DEFAULT_TITLE;
  }
};

export { handleUpdateTitle };
